module.exports = require("./yav.d.ts");